import { SVGProps } from "react";

export function Parcel(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.16949 11.6378V17.0213L11.9965 18.4918V6.75928"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.781 11.7803V16.9273L11.9965 18.4918"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.45202 15.3318L6.92252 15.4883M14.3875 11.0373L21.0805 11.9593C21.1844 11.9737 21.2902 11.9601 21.387 11.9198C21.4839 11.8796 21.5682 11.8142 21.6312 11.7304C21.6942 11.6466 21.7337 11.5475 21.7456 11.4433C21.7574 11.3391 21.7412 11.2336 21.6985 11.1378L19.781 6.82181L11.996 5.50781L4.17002 6.88481L2.30502 10.8928C2.26175 10.9856 2.24347 11.0881 2.25197 11.1901C2.26048 11.2922 2.29548 11.3902 2.35352 11.4746C2.41156 11.5589 2.49062 11.6267 2.58287 11.6711C2.67513 11.7155 2.77738 11.7351 2.87952 11.7278L9.54852 11.2643C9.68134 11.2551 9.80918 11.2101 9.91838 11.1339C10.0276 11.0577 10.114 10.9533 10.1685 10.8318L11.996 6.75981L13.8225 10.6233C13.8748 10.7338 13.9537 10.8295 14.0523 10.9018C14.1509 10.9741 14.2664 11.0207 14.3875 11.0373Z"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
